import noop from '@/utils/no-op'
import { ReactNode, createContext, useState } from 'react'

type AllProductsDropdownContextType = {
    isOpen: boolean
    currentCategory: string
    openAllProducts: () => void
    open: (category: string) => void
    close: () => void
}

const initialState: AllProductsDropdownContextType = {
    isOpen: false,
    currentCategory: '',
    openAllProducts: noop,
    open: noop,
    close: noop,
}

export const AllProductsDropdownContext =
    createContext<AllProductsDropdownContextType>(initialState)

export default function AllProductsDropdownContextProvider({
    children,
}: {
    children: ReactNode
}) {
    const [isOpen, setIsOpen] = useState(false)
    const [currentCategory, setCurrentCategory] = useState('')

    const openAllProducts = () => {
        setIsOpen(true)
        setCurrentCategory('')
    }

    const open = (category: string) => {
        setIsOpen(true)
        setCurrentCategory(category)
    }

    const close = () => {
        setIsOpen(false)
        setCurrentCategory('')
    }

    return (
        <AllProductsDropdownContext.Provider
            value={{
                isOpen,
                currentCategory,
                openAllProducts,
                open,
                close,
            }}
        >
            {children}
        </AllProductsDropdownContext.Provider>
    )
}
